var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.954,43.218c-0.781,0.781-0.781,2.047,0,2.828c2.631,2.631,2.631,6.912,0,9.543l-8.436,8.435 C40.244,65.298,38.55,66,36.748,66s-3.497-0.702-4.771-1.977c-2.63-2.631-2.63-6.911,0-9.542l4.218-4.218 c0.781-0.781,0.781-2.047,0-2.828c-0.78-0.781-2.048-0.781-2.828,0l-4.218,4.218c-4.19,4.19-4.19,11.008,0,15.198 c2.03,2.03,4.729,3.148,7.6,3.148c2.871,0,5.57-1.118,7.6-3.148l8.435-8.435c4.19-4.19,4.19-11.009,0-15.199 C52.001,42.437,50.735,42.437,49.954,43.218z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.852,29.148c-4.19-4.19-11.008-4.192-15.198,0l-8.436,8.435c-4.19,4.191-4.19,11.009,0,15.199 c0.39,0.391,0.902,0.586,1.414,0.586s1.024-0.195,1.414-0.586c0.781-0.781,0.781-2.047,0-2.828c-2.63-2.631-2.63-6.912,0-9.543 l8.436-8.435c2.631-2.63,6.911-2.63,9.542,0C65.298,33.251,66,34.945,66,36.748s-0.702,3.497-1.977,4.771l-4.217,4.217 c-0.781,0.781-0.781,2.047,0,2.828c0.781,0.781,2.047,0.781,2.828,0l4.217-4.217c2.03-2.03,3.148-4.729,3.148-7.6 C70,33.876,68.882,31.178,66.852,29.148z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.09513b88cb3cebf52a6ecf87d22fda3b.svg";
export { ForwardRef as ReactComponent };